module.exports = __webpack_public_path__ + "static/livingSpaces2-b49c1fd4d28b1fe307d3b7091a37175a.jpg";